module.exports = __webpack_public_path__ + "static/media/beachPet.78a4daf3.jpg";